import { render } from "./AnswerView.vue?vue&type=template&id=778f80ba"
import script from "./AnswerView.vue?vue&type=script&lang=js"
export * from "./AnswerView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__